export const formatINR = (n) => {
  if (n == null) return "—";
  return "₹" + Number(n).toLocaleString("en-IN");
};

// Convert a possibly-relative image URL (e.g. /api/uploads/...) to an absolute URL.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const absUrl = (u) => {
  if (!u) return "";
  if (u.startsWith("http://") || u.startsWith("https://") || u.startsWith("data:")) return u;
  return `${BACKEND_URL}${u}`;
};

export const statusMeta = (s) => {
  switch (s) {
    case "available":       return { label: "Available",       bg: "#20E3B2", color: "#0A0A14" };
    case "one_room_left":   return { label: "One room left",   bg: "#FFD166", color: "#0A0A14" };
    case "two_rooms_left":  return { label: "Two rooms left",  bg: "#FFB766", color: "#0A0A14" };
    case "sold_out":        return { label: "Sold out",        bg: "#FF4D4D", color: "#fff"    };
    default:                return { label: s || "—",          bg: "#fff",    color: "#0A0A14" };
  }
};

export const STATUS_OPTIONS = [
  { value: "available",      label: "Available" },
  { value: "one_room_left",  label: "One room left" },
  { value: "two_rooms_left", label: "Two rooms left" },
  { value: "sold_out",       label: "Sold out" },
];

export const WHATSAPP_NUMBER = "15559455427";
export const SUPPORT_PHONE = "+91-08069641099";
export const SUPPORT_PHONE_TEL = "+918069641099"; // raw tel URI (no spaces/hyphens)
export const SUPPORT_EMAIL = "support@thehomestaycompany.in";

export const buildWhatsAppUrl = (text) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text || "Hi THC! I'd like to know more about your multiliving homes.")}`;
